import { createContext } from "react";

export { default } from "./View";

type MetricsContextType = {
  error?: Error;
  setError?: (message?: unknown) => void;
  enableThreshold?: boolean;
};

export const MetricsContext = createContext<MetricsContextType | undefined>({});
